import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const CircleClock: FC<Props> = (props) => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="circle clock icon">
      {/* <title>circle clock icon</title> */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00012 3.41786C5.84548 3.41786 3.28858 5.97475 3.28858 9.12939C3.28858 12.2834 5.84552 14.8409 9.00012 14.8409C12.1548 14.8409 14.7117 12.2834 14.7117 9.12939C14.7117 5.97475 12.1548 3.41786 9.00012 3.41786ZM2.25012 9.12939C2.25012 5.40123 5.27196 2.37939 9.00012 2.37939C12.7283 2.37939 15.7501 5.40123 15.7501 9.12939C15.7501 12.8568 12.7283 15.8794 9.00012 15.8794C5.27191 15.8794 2.25012 12.8568 2.25012 9.12939Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.76923 6.12939C9.05598 6.12939 9.28846 6.36186 9.28846 6.64863V9.19122L11.2335 10.3536C11.4797 10.5007 11.56 10.8195 11.4129 11.0657C11.2658 11.3118 10.947 11.3921 10.7008 11.245L8.50283 9.9315C8.34602 9.83776 8.25 9.66856 8.25 9.48579V6.64863C8.25 6.36186 8.48248 6.12939 8.76923 6.12939Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
    </svg>
  );
};

export default CircleClock;
